<template>
  <vx-card>
    <h4 class="mb-2">Workplace Preparation</h4>
    <p class="my-5">
      You can view your student's responses to the Workplace Preparation modules below
    </p>

    <div class="workplace_preparation_modules">
      <div class="workplace_module" v-for="(module, index) in moduleNames" :key="index">
        <p class="module_name">{{ index }}. {{ module }}</p>
        <status-icon
          :type="
            typeof prework.workplace_preparation_modules_completed !== 'undefined' &&
            prework.workplace_preparation_modules_completed[index] === true
              ? 'completed'
              : 'not_completed'
          "
          class="prework_icon large_icon"
        /><br />
      </div>
    </div>
    <router-link
      class="btn btn-secondary btn-size-medium mt-5 inline-block"
      :to="'/teacher/vje/activity/student/' + this.$route.params.id"
    >
      Back
    </router-link>
  </vx-card>
</template>

<script>
import StatusIcon from '@/components/UI/StatusIcon';
import theApi from '@/mixins/theApi';
import store from '@/store/store';

export default {
  components: { StatusIcon },
  data() {
    return {
      prework: false,
      moduleNames: {
        1: 'Contacting an Employer',
        2: 'Personal Presentation',
        3: 'Employer expectations and your rights',
        4: 'Communication',
        5: 'WHS (Workplace Health and Safety)',
        6: 'Work Experience Checklist',
        7: 'Work Experience Questions',
      },
    };
  },
  methods: {
    async loadStudents() {
      theApi.methods.makeCall(true, 'vje_students/student/' + this.$route.params.id, 'get').then(
        (data) => {
          this.prework = data.data.prework;
        },
        () => {},
      );
    },
    showWorkExperience() {
      store.dispatch('popup/showIframePopup', this.prework.workplace_safety_url);
    },
  },
  mounted() {
    this.loadStudents();
  },
};
</script>

<style lang="scss" scoped>
.workplace_module {
  overflow: hidden;
  padding: 10px 0;
  border-bottom: 1px solid #dedede;
  display: flex;
  align-items: center;
}
.workplace_module:last-child {
  border-bottom: none;
}
.module_name {
  font-size: 14px;
  font-weight: 600;
}
.prework_icon {
  width: auto;
  margin-left: auto;
}

::v-deep {
  .prework_icon.large_icon .status_icon {
    height: 30px !important;
    width: 30px !important;
  }
}

@media (min-width: 768px) {
  .module_name {
    font-size: 16px;
  }

  .prework_icon {
    width: 10%;
  }

  ::v-deep {
    .prework_icon.large_icon .status_icon {
      height: 40px !important;
      width: 40px !important;
    }
  }
}
</style>
